import { CommonModule, registerLocaleData } from '@angular/common';
/* ------ LANGUAGE ---------------------*/
import localeDe from '@angular/common/locales/de';
import { LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';

/* ------ CORE IMPORTS -----------  */
import { CoreFrontendSharedModule, FeatureRouterLinkResolverService, NgLetDirective, provideAuthStrategyConfig } from '@core/frontend-shared';
import { provideRootRoutes, routerProviderFactory } from '@core/frontend-shared/router';

/* ------ COMMON IMPORTS -----------  */
import { CmsFrontendSharedModule } from '@common/cms/frontend-shared';
import { FeedbackButtonComponent } from '@common/feedback/frontend';
import { LayoutFrontendSharedModule } from '@common/layout/frontend-shared';
import { LayoutContentbarComponents } from '@common/layout/frontend-shared/contentbars';
import { LayoutRouterOutletFullscreenComponent } from '@common/layout/frontend-shared/router-outlet-fullscreen';
import { LayoutSidebarComponent, LayoutSidebarWrapperComponent } from '@common/layout/frontend-shared/sidebar';
import { LayoutToolbarComponent } from '@common/layout/frontend-shared/toolbar';
import { LocalstateFrontendSharedModule } from '@common/localstate/frontend-shared';
import { MinimalUiModule } from '@common/ui/frontend-shared';
import { UiScreenServiceModule } from '@common/ui/frontend-shared/screen-service';
import { UiTabMenuComponent } from '@common/ui/frontend-shared/tabmenu';

/* ------ FEATURE IMPORTS -----------  */
import { UiRequiredModule } from '@pflegetheke/ui/frontend-shared';
import { LayoutFrontpageComponent } from '@pflegetheke/ui/frontend-shared/layout-frontpage';

/* ------ LOCAL IMPORTS -----------  */
import { AppComponent } from './components/app.component';
import { LandingpageComponent } from './components/landingpage/landingpage.component';
import { AppLoginComponent } from './components/login/login.component';
import { ScopeMetadataService } from './scope-metadata.service';

import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { UserAuthenticationComponent } from '@common/users/frontend-shared';
import features from './features';

registerLocaleData(localeDe);








const preloadCmsModulesForRoutes = [
	'/','/privacy','/imprint', '/terms'
]

const states: any[] = [];

const persist: string[] = ['local','language'];

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserModule,
		ServiceWorkerModule.register('ngsw-worker.js?v='+VERSION, { 
			enabled: IS_PRODUCTION, 
			// Register the ServiceWorker as soon as the app is stable
			// or after 30 seconds (whichever comes first).
			registrationStrategy: 'registerWhenStable:30000' 
		}),
		ReactiveFormsModule,

		// must be imported BEFORE Core library!
		NgxsModule.forRoot(states, { 
			developmentMode: !IS_PRODUCTION,
			selectorOptions: { suppressErrors: false }
		}),
		NgxsStoragePluginModule.forRoot({ keys: persist }),
		(!IS_PRODUCTION) ? NgxsReduxDevtoolsPluginModule.forRoot({}) : [],

		CoreFrontendSharedModule.forRoot({}),
		
		RouterModule.forRoot([/* routes provided using provideRootRoutes()! */], { 
			initialNavigation: 'enabledBlocking',
			paramsInheritanceStrategy:'always',
			scrollPositionRestoration:'top',
			// anchorScrolling: 'enabled',
		}),
		BrowserAnimationsModule,
		
		NgLetDirective,
		CmsFrontendSharedModule.forRoot({preloadCmsModulesForRoutes}),
		LocalstateFrontendSharedModule,
		UiScreenServiceModule.forRoot(),
		MinimalUiModule.forRoot(),
		UiRequiredModule,
		UiTabMenuComponent,
		
		LayoutFrontendSharedModule.forRoot(),
		...LayoutContentbarComponents,
		LayoutToolbarComponent,
		LayoutSidebarComponent, LayoutSidebarWrapperComponent,
		LayoutRouterOutletFullscreenComponent,
		LayoutFrontpageComponent,

		UserAuthenticationComponent,
		FeedbackButtonComponent,
		LandingpageComponent,
		AppLoginComponent,

		...features,
		
	],
	providers: [
		{ provide: APP_ID, useValue: 'pflegetheke-frontend-ssr' },
		{provide: LOCALE_ID, useValue: "de-DE"},
		provideHttpClient(
			withFetch(),
			withInterceptorsFromDi(),
		),
		provideClientHydration(),
		provideRootRoutes([
			{ path: 'login', data:{ pageTitle:'Login/Anmeldung', layout:'fullscreen,showBottomBar' }, component: AppLoginComponent },
			{ path: '', pathMatch: 'full', component: LandingpageComponent, data: {layout:'fullscreen,showBottomBar'}	},
		]),
		...routerProviderFactory(),
		provideAuthStrategyConfig('credentials',{})
	],
	bootstrap: [AppComponent],
	exports: [
		CommonModule,
		UiRequiredModule,
	]
})
export class AppModule {
	constructor(
		test:FeatureRouterLinkResolverService,
		scopeMeta:ScopeMetadataService,
	) {}
}
